var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nft-item"},[_c('img',{style:({
		width: '100%',
		height: _vm.height,
	})}),_c('div',{staticClass:"label text-color"},[_vm._v(" dgsdgshgdgjsg ")]),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nft-bottom"},[_c('div',{staticClass:"bottom-left"},[_c('span',{staticClass:"value text-color"},[_vm._v("2500")]),_c('span',{staticClass:"transform text-sub-color"},[_vm._v("≈$0.57")])]),_c('div',{staticClass:"bottom-right"},[_c('img',{staticStyle:{"width":"16px","height":"14px"},attrs:{"src":require("@/assets/images/star.png")}}),_c('span',{staticClass:"star text-sub-color"},[_vm._v("12345")])])])
}]

export { render, staticRenderFns }